import { Component, Input } from '@angular/core';

@Component({
  selector: 'fg-spinner',
  templateUrl: './fg-spinner.component.html',
  styleUrls: ['./fg-spinner.component.scss']
})
export class FgSpinnerComponent {
  @Input() public saving: boolean;
  @Input() public fillParent: boolean;
  constructor() {}
}
